import LocalizedStrings from 'react-localization';

const Strings = new LocalizedStrings({
    en: {
        ok: 'OK',
        no: 'No',
        yes: 'Yes',
        cancel: 'Cancel',
        discard: 'Discard',
        next: 'Next',
        back: 'Back',
        save: 'Save',
        pageTitle: 'eWay-CRM | Welcome',

        components: {
            main: {
                title: 'Welcome',
                titleLoaded: 'Welcome to',
                errorTitle: 'Oops',
                errorWS: 'Web Service returned an error',
                errorRequest: 'Request returned an error',
                errorWebServiceMoved: 'Web service was moved',
                errorSeeMore: 'See more',
                errorSeeLess: 'See less',
                statusWS: 'Check Web Service Status',
            },
            cardContainer: {
                title: 'Where Do You Want to Start?',
            },
            cards: {
                titleOutlook: 'eWay-CRM Desktop',
                titleWeb: 'eWay-CRM Online',
                titleMobile: 'eWay-CRM Mobile',
                titleAdminCenter: 'Admin Center',
                titleContactSupport: 'Support & Community',
                btnMobile: 'Get',
                btnAdmin: 'Log In',
                btnWebInstall: 'Install',
                btnWebLogIn: 'Log In',
                btnOutlook: 'Download',
                btnHelpdesk: 'Get Help',
                linkSupport: 'https://eway.cr/preview_support',
            },
            rssFeed: {
                title: 'Latest Posts',
                feedLink: 'https://www.eway-crm.com/feed/?r=welcome',
                feedError: 'Unable to load latest posts',
                articleLink: 'Go to the Article',
            },
            videoCarousel: {
                title: 'Begin Your Tour',
            },
            socials: {
                title: 'Follow Us',
                facebookLink: 'https://www.facebook.com/eWayCRM',
                linkedInLink: 'https://www.linkedin.com/company/eway-system-en-',
                youtubeLink: 'https://www.youtube.com/channel/UChpgTL5pGMNukezqTz0eK4w',
                redditLink: 'https://www.reddit.com/r/ewaycrm/',
                instagramLink: 'https://www.instagram.com/ewaycrm/',
            },
        },
    },
    cs: {
        ok: 'OK',
        no: 'Ne',
        yes: 'Ano',
        cancel: 'Zrušit',
        discard: 'Storno',
        next: 'Další',
        back: 'Zpět',
        save: 'Uložit',
        pageTitle: 'eWay-CRM | Vítejte',

        components: {
            main: {
                title: 'Vítejte',
                titleLoaded: 'Vítejte v',
                errorTitle: 'Jejda',
                errorWS: 'Webová služba vrátila chybu',
                errorRequest: 'Požadavek vrátil chybu',
                errorWebServiceMoved: 'Webová služba byla přesunuta',
                errorSeeMore: 'Zobrazit více',
                errorSeeLess: 'Zobrazit méně',
                statusWS: 'Ověřit status webové služby',
            },
            cardContainer: {
                title: 'Kde si přejete začít?',
            },
            cards: {
                titleOutlook: 'eWay-CRM Desktop',
                titleWeb: 'eWay-CRM Online',
                titleMobile: 'Mobilní aplikace',
                titleAdminCenter: 'Centrum pro správu',
                titleContactSupport: 'Podpora a komunita',
                btnMobile: 'Získat',
                btnAdmin: 'Přihlásit se',
                btnWebInstall: 'Instalovat',
                btnWebLogIn: 'Přihlásit se',
                btnOutlook: 'Stáhnout',
                btnHelpdesk: 'Získat pomoc',
                linkSupport: 'https://eway.cr/preview_support_cz',
            },
            rssFeed: {
                title: 'Nejnovější příspěvky',
                feedLink: 'https://www.eway-crm.com/cs/feed/?r=welcome',
                feedError: 'Příspěvky se nepodařilo načíst',
                articleLink: 'Přejít na článek',
            },
            videoCarousel: {
                title: 'Inspirujte se',
            },
            socials: {
                title: 'Sledujte nás',
                facebookLink: 'https://www.facebook.com/eWayCRM.cz/',
                linkedInLink: 'https://www.linkedin.com/company/eway-system/',
                youtubeLink: 'https://www.youtube.com/user/eWayCRM',
                redditLink: 'https://www.reddit.com/r/ewaycrm/',
                instagramLink: 'https://www.instagram.com/ewaycrm/',
            },
        },
    },
});

export default Strings;
